<!--
 * @Author: cmchiu
 * @Date: 2023-01-03 17:59:58
 * @LastEditTime: 2023-01-04 15:21:48
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\components\CourseClass\courseclass.vue
 * 
-->
<template>
    <div class="course-class">
        <!-- menu -->
        <div class="row d-lg-block d-md-none d-sm-none d-none mt-3 mb-3">
            <div class="col-lg-12">
                <ul class="nav LM_nav justify-content-center">
                    <li class="nav-item">
                        <router-link
                            class="nav-link"
                            :class="!$route.query.class ? 'active' : ''"
                            :to="{ path: '/courselist' }"
                        >
                            全部
                        </router-link>
                    </li>
                    <li class="nav-item" v-for="item in courseClass" :key="item.para_no">
                        <router-link
                            class="nav-link"
                            :class="$route.query.class && $route.query.class === item.para_phsiname ? 'active' : ''"
                            :to="{ path: '/courselist', query: { class: item.para_phsiname } }"
                        >
                            {{ item.para_dispname }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 手機版 menu -->
        <div class="row d-lg-none d-md-block d-sm-block d-block">
            <div class="col-lg-12 mt-3 mb-3 pl-0 pr-0">
                <nav class="navbar LM_nav_m">
                    <div class="container-fluid">
                        <button
                            class="navbar-toggler"
                            :class="openMobileMenu ? '' : 'collapsed'"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarToggleExternalContent"
                            aria-controls="navbarToggleExternalContent"
                            :aria-expanded="openMobileMenu"
                            aria-label="Toggle navigation"
                            @click="toggleMobileMenu"
                        >
                            課程分類
                            <i class="fa-solid fa-angle-right angle_right" v-if="!openMobileMenu"></i>
                            <i class="fa-solid fa-angle-down angle_down" v-if="openMobileMenu"></i>
                        </button>
                    </div>
                </nav>
                <div
                    class="collapse LM_nav_collapse"
                    :class="openMobileMenu ? 'show' : ''"
                    id="navbarToggleExternalContent"
                >
                    <div class="p-4">
                        <ul>
                            <li>
                                <router-link
                                    :class="!$route.query.class ? 'active' : ''"
                                    :to="{ path: '/courselist' }"
                                    @click.native="toggleMobileMenu"
                                >
                                    <i class="fa-solid fa-angles-right" v-if="!$route.query.class"></i> 全部
                                </router-link>
                            </li>
                            <li v-for="item in courseClass" :key="item.para_no">
                                <router-link
                                    :class="
                                        $route.query.class && $route.query.class === item.para_phsiname ? 'active' : ''
                                    "
                                    :to="{ path: '/courselist', query: { class: item.para_phsiname } }"
                                    @click.native="toggleMobileMenu"
                                >
                                    <i
                                        class="fa-solid fa-angles-right"
                                        v-if="$route.query.class && $route.query.class === item.para_phsiname"
                                    ></i>
                                    {{ item.para_dispname }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCourseClass } from '@/api/course'

export default {
    name: 'courseclass',

    data: function () {
        return {
            configs: {
                loading: false,
            },
            courseClass: [],
            openMobileMenu: false,
        }
    },

    created: function () {
        this.getCourseClass()
    },

    methods: {
        async getCourseClass() {
            await getCourseClass({}).then(res => {
                if (res.Code === 1) {
                    this.courseClass = res.Items
                    // this.$message({
                    //     message: res.Msg,
                    //     type: 'success',
                    // })
                }
            })
        },

        toggleMobileMenu() {
            this.openMobileMenu = !this.openMobileMenu
        },
    },
}
</script>
